import React, { useContext, useMemo, useState } from 'react'
import { Button, Col, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer } from '../../components/Question'
import { useCaptureValue } from '../../hooks/use-capture-question'
import useStep from '../../hooks/use-step'
import { Contribution } from '../../interfaces/contribution'
import { Paths } from '../../routes/paths'
import { GbsStore } from '../../store'
import { GbsStep } from '../../store/interfaces'
import { useStepData } from '../../store/selectors'

const stepKey = 'contribution'

export const TotalAmount = () => {
  const { dispatch } = useContext(GbsStore)
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const haveCurrentlyMedical = useStepData('currentlyMedical').value

  const contributionInit = () => {
    if (stepData?.type && stepData?.value) {
      return stepData
    }

    const defaultValue = {
      value: '50',
      type: Contribution.PERCENTAGE
    }

    return defaultValue
  }

  const [contribution, setContribution] =
    useState<{
      value: number | string
      type: Contribution
    }>(contributionInit)

  const rangeOptions = [
    {
      name: Contribution.PERCENTAGE,
      range: { from: 0, to: 100 },
      symbol: '%'
    },
    {
      name: Contribution.DOLLAR,
      range: { from: 0, to: 100 },
      symbol: '$'
    }
  ]

  const { captureAnswer, isLoading } = useCaptureValue(
    stepKey,
    {
      employer_contribution_employee_amount: Number(contribution.value) || 0,
      employer_contribution_amount_type: contribution.type
    },
    contribution,
    { plainValue: true }
  )

  // const isDisabled = !contribution?.value || isLoading

  const onContinue = async () => {
    if (!(await captureAnswer())) return

    history.push(Paths.totalAmountDependent)
  }

  const stepConfig: Omit<GbsStep, 'data'> = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 40,
        backCallback: () => {
          const url = haveCurrentlyMedical
            ? Paths.switchingCoverage
            : Paths.newHealth
          history.push(url)
        }
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history, haveCurrentlyMedical])

  useStep(stepKey, stepConfig, dispatch)

  return (
    <QuestionContainer>
      <Row>
        <Col xs={12} className="px-5">
          <Question
            type="range"
            text="What amount of total coverage cost will you be covering for each employee?"
            rangeOptions={rangeOptions}
            defaultValue={
              contribution?.type === Contribution.DOLLAR &&
              Number(contribution.value) === 0
                ? undefined
                : contribution?.value || 50
            }
            defaultRangeName={contribution?.type}
            onChange={(value, { name }) => {
              let update

              if (name !== contribution.type) {
                update =
                  name === Contribution.DOLLAR
                    ? { type: Contribution.DOLLAR, value: undefined }
                    : { type: Contribution.PERCENTAGE, value: 50 }
              } else {
                update = {
                  value: Number(value),
                  type: name
                }
              }

              setContribution(update as any)
            }}
          ></Question>
        </Col>
      </Row>

      <div className="text-center">
        <Button
          style={{ width: 130, marginTop: 5 }}
          variant="primary"
          onClick={onContinue}
          disabled={
            isLoading ||
            (contribution.type === Contribution.DOLLAR && !contribution.value)
          }
        >
          Next
        </Button>
      </div>
    </QuestionContainer>
  )
}

export default TotalAmount
